export default {
  title: {
    tradeData: 'FiinTA',
    titleHeader: 'Ultimate Data Source for Amibrokers',
  },
  button: {
    download: 'Download',
    userManual: 'User Manual',
    historicalData: 'FULL EOD HISTORICAL DATA',
    realTimeData: 'REAL-TIME DATA UPDATED',
    dataEveryMinute: 'Intraday data tick by tick',
    pluginConnect: 'PLUGIN CONNECT',
    comprehensiveData: 'COMPREHENSIVE DATA',
    easyToUse: 'EASY TO USE',
  },
};
